/**
 * @generated SignedSource<<2402846491c27ad0336cfd6f800af55f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AdvertisementCampaign = "FRAMER_AD_EXPERIMENT" | "VISUAL_ELECTRIC_ADS" | "WIX_STUDIO_ADS" | "%future added value";
export type AdvertisementLocation = "ANALYTICS_TAB" | "DISCOVER_TOOL_SUGGESTION" | "EXPERT_PAGE" | "INDEPENDENT_HOME" | "JOBS_PAGE" | "PROJECT_CREATION" | "SERVICES_CREATION" | "SIDE_NAV" | "SPONSORED_CHAT_CONVERSATION" | "%future added value";
export type AutonomousSystemType = "BUSINESS" | "EDUCATION" | "GOV" | "GOVERNMENT" | "HOSTING" | "INACTIVE" | "ISP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AppPreload_visitor$data = {
  readonly advertisementCampaigns: ReadonlyArray<{
    readonly campaign: AdvertisementCampaign;
    readonly locations: ReadonlyArray<AdvertisementLocation>;
  }> | null;
  readonly featureFlags: ContraAPIScalars.JSON | null;
  readonly id: string;
  readonly impersonator: {
    readonly id: string;
  } | null;
  readonly ipAddress: {
    readonly address: string;
    readonly autonomousSystem: {
      readonly id: string;
      readonly type: AutonomousSystemType;
    } | null;
    readonly id: string;
  } | null;
  readonly sessionId: string;
  readonly traits: ContraAPIScalars.JSON | null;
  readonly userAccount: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CurrentUser">;
  } | null;
  readonly " $fragmentType": "AppPreload_visitor";
};
export type AppPreload_visitor$key = {
  readonly " $data"?: AppPreload_visitor$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppPreload_visitor">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppPreload_visitor",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "traits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "featureFlags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserAccount",
      "kind": "LinkedField",
      "name": "impersonator",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserAccount",
      "kind": "LinkedField",
      "name": "userAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CurrentUser"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IpAddress",
      "kind": "LinkedField",
      "name": "ipAddress",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AutonomousSystem",
          "kind": "LinkedField",
          "name": "autonomousSystem",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisitorAdvertisementCampaign",
      "kind": "LinkedField",
      "name": "advertisementCampaigns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "campaign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locations",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Visitor",
  "abstractKey": null
};
})();

(node as any).hash = "0231abf731edde064c6e68f3077437b7";

export default node;
